export default "__VITE_ASSET__Dnh1e1J8__"